/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Tournaments_Calendar_Scope_LabelInputs */



/**
* | output |
* | --- |
* | "Calendar for: {scope}" |
*
* @param {Tournaments_Calendar_Scope_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_scope_label = /** @type {((inputs: Tournaments_Calendar_Scope_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_Scope_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Calendrier pour : ${i?.scope}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Calendario para: ${i?.scope}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Calendário para: ${i?.scope}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Calendario per: ${i?.scope}`)
	return /** @type {LocalizedString} */ (`Calendar for: ${i?.scope}`)
});